import { createSlice } from '@reduxjs/toolkit';

// Initial state, adapters
const initialState = {
  unseenShortlistedCandidatesCount: 0, // Used to track # of unseen shortlisted candidates and display in a navigation badge. It resets when shortlisted candidates page is opened.
};

// Slice
const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    RESET: () => initialState,
    resetUnseenShortlistedCandidatesCount: (state) => {
      state.unseenShortlistedCandidatesCount = 0;
    },
    incrementUnseenShortlistedCandidatesCount: (state) => {
      state.unseenShortlistedCandidatesCount += 1;
    },
    decrementUnseenShortlistedCandidatesCount: (state) => {
      if (state.unseenShortlistedCandidatesCount > 0) state.unseenShortlistedCandidatesCount -= 1;
    },
  },
  extraReducers: {},
});

// Selectors
export const selectFirebaseUser = (state) => state.app.firebaseUser;
export const selectUnseenShortlistedCandidateCount = (state) => state.app.unseenShortlistedCandidatesCount;

// Actions and Reducers
export const appActions = appSlice.actions;
export default appSlice.reducer;
